import { createTheme } from '@mui/material/styles';

import type { ThemeConfig } from 'src/types/themeConfig';
import { merge } from 'src/utils/lodashKiller';

import { composeTheme } from './themes/base';
import customerPages from './themes/customerPages';

import type { Theme } from '@mui/material';

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    success: true;
    error: true;
    warning: true;
    info: true;
    action: true;
  }
}

declare module '@mui/material/AppBar' {
  interface AppBarPropsColorOverrides {
    success: true;
    error: true;
    warning: true;
    info: true;
    action: true;
  }
}

declare module '@mui/material/Chip' {
  interface ChipPropsColorOverrides {
    success: true;
    error: true;
    warning: true;
    info: true;
    action: true;
  }
}

declare module '@mui/material/InputBase' {
  interface InputBaseComponentsPropsOverrides {
    'data-1p-ignore'?: boolean;
  }
}

export const createCustomTheme = (config: ThemeConfig = {}, themeExtension = ''): Theme => {
  let theme = createTheme(
    composeTheme(config),
  );

  let themeExtensionObject = null;
  switch (themeExtension) {
    case 'customerPages':
      themeExtensionObject = customerPages;
      break;
    default:
      break;
  }

  if (themeExtensionObject) {
    theme = merge(theme, themeExtensionObject.ALL);

    if ((config?.theme) && themeExtensionObject[config.theme]) theme = merge(theme, customerPages[config.theme]);
  }

  return theme;
};
